import { combineReducers } from 'redux';
import sitesReducer from './sites';
import requirementsReducer from './requirements';
import formReducer from './form';
import dirty from './dirty';

export default combineReducers({
  sites: sitesReducer,
  requirements: requirementsReducer,
  form: formReducer,
  dirty,
});

export const isFetching = state => {
  return (
    state.sites.isFetching ||
    state.requirements.isFetching ||
    state.form.isFetching
  );
};



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases-creation/step2/reducers/index.js